export const cdnHost = '//d1qxh16sy9h7uh.cloudfront.net';


// WEBPACK FOOTER //
// ./src/settings.jsx